import { Injectable } from '@angular/core';
import { Documents } from '../model/documents';
import { HttpClient, HttpEventType } from '@angular/common/http';
interface myData{
  success : boolean,
  message : string
}
@Injectable()
export class DocumentsService {
  _documentList:Documents[] = [];
  public _date;
  public _title;
  public docImage;
  public doc;
  constructor(private Http : HttpClient) { }

  options = [
    {value: 'O Levels Certificate'},
    {value:'Post Secondary Certificate'},
    {value: 'Others'}
  ]
  // uploadFile(e){
  //   let elem = e.target;
  //   if(elem.files.length > 0){
  //     console.log(elem.files[0]);
  //   }
  // }
  addDocument(document:Documents){
    this._date = new Date();
    document.date = (this._date.getDate())+"-"+ (this._date.getMonth()+1)+"-"+ (this._date.getFullYear());
    this._documentList.push(document);
  }
  deleteDoc(sn:number){
    const doc = this._documentList.findIndex(c => c.sn ===sn);
    this._documentList.splice(doc, 1);
  }
  getAllDocs(){
    return this._documentList;
  }

  sendDoc(doc){
    return this.Http.post<any>('/edozzier/portal-upload-file.php',doc,{
        reportProgress:true,
        observe: 'events'
    });
  }
  displayDocs(){
    return this.Http.get<any>('/edozzier/portal-document-list.php');
  }
  getDoc(doc){
    this.doc = doc;
  }
  deleteDocument(id){
    return this.Http.post<any>('/edozzier/portal-delete-document.php',id);
  }
}
